export default {
  packs: {
    packListTab: {
      title: "Список пачек",
      reasonReturningPackForm: {
        modal: {
          title: "Причина возврата пачки",
          form: {
            reasons: "Причины"
          }
        }
      },
      alert: {
        postingAllPrepare: "Нет ни одной пачки для разноски.",
        lastMessagePackVerification: {
          verificationCompleted: "Проверка завершена.",
          checked: "Проверено",
          bugsFound: "Обнаружено ошибок:"
        },
        postingAllContinue: "Разноска пачек завершена"
      },
      confirm: {
        postingPrepare: "Разнести выбранную пачку по лицевым?",
        postingAllPrepare: {
          messageCountPacks: "Количество пачек для разноски",
          messagePostingAll: "Запустить разноску пачек по лицевым?"
        },
        onReturnBtn:
          "Установить ошибочность выбранной пачки и отправить ее бухгалтеру?",
        onPostponeBtn:
          "Отложить выбранную пачку для автоматической разноски ночью?",
        onPostingAllBtn: "Разнести все корректно заполненные пачки по лицевым?"
      }
    },
    packSelectedTab: {
      title: "Пачка №",
      countbandsEditForm: {
        modal: {
          title: {
            payments: "Бандероль",
            subsidies: "Лист"
          }
        },
        form: {
          number: {
            payments: "Номер бандероли",
            subsidies: "Номер листа"
          },
          quantity: {
            payments: "Кол-во квитанций",
            subsidies: "Кол-во абонентов"
          },
          totalSum: "Общая сумма"
        }
      },
      countbandsName: {
        payments: "Бандероли",
        subsidies: "Листы"
      },
      oneCountbandName: {
        payments: "Бандероль №",
        subsidies: "Лист №"
      },
      countbandsTotal: {
        pack: "По пачке",
        payments: {
          countband: "По бандероли",
          countbands: "По бандеролям",
          receipts: "По квитанциям"
        },
        subsidies: {
          list: "По листу",
          lists: "По листам",
          socials: "По субсидиям/соц.доплатам"
        }
      },
      paymentTitle: {
        compensationForVisuallyImpaired:
          "Компенсация инвалидам по зрению Л: {countband} С: {receipt}",
        socialSurcharge: "Соц.доплата Л: {countband} С: {receipt}",
        subsidy: "Субсидия Л: {countband} С: {receipt}",
        receipt: "Квитанция Б: {countband} Кв: {receipt}"
      },
      alert: {
        importPackIsNotChanged:
          "Данные импортированной пачки не могут быть изменены",
        maxCountbandsHasAlreadyBeenEntered:
          "Необходимое количество бандеролей уже внесено",
        maxListsHasAlreadyBeenEntered:
          "Необходимое количество листов уже внесено",
        deleteCountband: "Удалить бандероль?",
        deleteList: "Удалить лист?",
        maxReceiptsHasAlreadyBeenEntered:
          "Необходимое количество квитанций уже внесено",
        maxSubsidiesHasAlreadyBeenEntered:
          "Необходимое количество субсидий уже внесено"
      },
      confirm: {
        deletePayment: "Удалить платеж?",
        deleteAllCountband: "Удалить содержимое бандероли?",
        deleteAllList: "Удалить содержимое листа?"
      }
    }
  }
};
